import React from "react";
import { Outlet } from "react-router-dom";

export const LayoutAuth = () => {
	return (
		<div className="bg-red_primary fixed top-0 w-full h-full z-0">
			<Outlet />
		</div>
	);
};
